import { ChevronUpIcon } from '@chakra-ui/icons';
import { Collapse } from '@chakra-ui/react';
import { useState } from 'react';

import { TreeSelection } from '../tree/TreeSelection';
import type { TreeData } from '../tree/useTreeApi';
import styles from './SelectedItems.module.css';

const SELECTED_HEIGHT = 80;

export interface SelectedItem {
  id: string;
  name: string;
}

interface SelectedItemsProps {
  items: SelectedItem[];
  onRemove: (id: string) => void;
}

export const SelectedItems: React.FC<SelectedItemsProps> = ({
  items,
  onRemove,
}) => {
  const [isOpen, setIsOpen] = useState(true);

  if (items.length === 0) return null;

  const treeData: TreeData[] = items.map((item) => ({
    id: item.id,
    name: item.name,
    depth: 0,
  }));

  const selectedIds = items.map((item) => item.id);

  const handleChange = (newIds: string[]) => {
    const removed = selectedIds.find((id) => !newIds.includes(id));
    if (removed) onRemove(removed);
  };

  return (
    <div className={styles.container}>
      <button
        className={styles.toggle}
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className={styles.label}>{`${items.length} Selected`}</span>
        <ChevronUpIcon
          boxSize={7}
          transform={isOpen ? 'rotate(180deg)' : undefined}
          transition="transform 0.2s"
        />
      </button>
      <Collapse in={isOpen}>
        <div onWheel={(e) => e.stopPropagation()}>
          <TreeSelection
            data={treeData}
            value={selectedIds}
            onChange={handleChange}
            height={SELECTED_HEIGHT}
            skipDefaultSort
            flattenIndentation
          />
        </div>
      </Collapse>
    </div>
  );
};
